function counter() {
    const counterElements = document.querySelectorAll('.counter-num');

if (counterElements.length > 0) {
    counterElements.forEach(el => {
        const numCounterEl = el;
        const numCounterVal = numCounterEl.textContent;
        const numValueElement = document.createElement('span');
        numValueElement.className = 'num-value';

        // Регулярное выражение для поиска числа в тексте
        const numberRegex = /(\d[\d\s,.-]*)/;

        // Находим числа в тексте и оборачиваем их в элемент numValue
        const numCounterText = numCounterVal.replace(numberRegex, (match) => {
            const numValueSpan = numValueElement.cloneNode(true);
            numValueSpan.textContent = match;
            return numValueSpan.outerHTML;
        });

        numCounterEl.innerHTML = numCounterText;

        const numValueElements = numCounterEl.querySelectorAll('.num-value');

        numValueElements.forEach(numValue => {
            const numCounterVal = numValue.textContent;

            // Удаляем пробелы и заменяем запятые на точки
            const numCounter = parseFloat(numCounterVal.replace(/[^\d,.-]/g, '').replace(/\s/g, '').replace(',', '.'));

            let startNum = 0;
            let duration = 1000;
            let startTime = null;

            function animateCounter(timestamp) {
                if (!startTime) startTime = timestamp;

                const progress = timestamp - startTime;

                startNum = Math.min((progress / duration) * numCounter, numCounter);

                // Форматируем число обратно с пробелами и заменой точки на запятую, если изначально было дробное
                const formattedNum = numCounterVal.includes(',') ? startNum.toFixed(1).replace('.', ',') : Math.round(startNum);
                
                // Форматируем с добавлением пробелов для удобства чтения
                numValue.textContent = formattedNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

                if (progress < duration) {
                    requestAnimationFrame(animateCounter);
                }
            }

            const observerCounter = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        requestAnimationFrame(animateCounter);
                    }
                });
            }, { threshold: [0.5] });

            observerCounter.observe(el.parentElement);
        });
    });
}

}
  
export default counter;
  